import React from 'react'
import {useQuery} from '@apollo/react-hooks'
import gql from 'graphql-tag'
import {Link} from '@reach/router'

import {Page, Heading, Box} from '../../components/layout/page'
import {Table, Cell} from '../../components/layout/table'

import {PageLoader} from '../../components/elements/loader'

const SUPPLIER_QUERY = gql`
  query Supplier($supplier: ID!){
    contact(id: $supplier){
      id
      name
      purchaseOrders{
        count
        purchaseOrders{
          id
          orderNumber
        }
      }
      items{
        count
        items{
          id
          stockControlNumber
          product{
            id
            name
          }
        }   
      }
    }
  }
`

interface SupplierResponse{
  contact: {
    id: number
    name: string
    purchaseOrders: {
      count: number
      purchaseOrders: {
        id: number
        orderNumber: string
      }[]
    }
    items: {
      count: number
      items: {
        id: number
        stockControlNumber: string
        product: {
          id: number
          name: string
        }
      }[]
    }
  }
}

export const Supplier: React.FC<{path: string, supplier?: string}> = ({supplier: supplierId}) => {
  const {loading, error, data} = useQuery<SupplierResponse>(SUPPLIER_QUERY, {variables: {
    supplier: supplierId
  }})

  if(loading){
    return <PageLoader title="Loading Supplier" message="Loading supplier" />
  }

  if(error){
    throw error
  }

  const supplier = data!.contact

  return <Page>
    <Heading text={supplier.name} actions={[]} />
    <Box cols={1}>
      <h2>Purchase Orders ({supplier.purchaseOrders.count})</h2>
      <Table>
        <thead>
          <tr>
            <th>PO</th>
          </tr>
        </thead>
        <tbody>
          {supplier.purchaseOrders.purchaseOrders.map((purchaseOrder) => {
            return <tr key={purchaseOrder.id}>
              <Cell><Link to={`/quote/${purchaseOrder.id}`}>{purchaseOrder.orderNumber}</Link></Cell>
            </tr>
          })}
        </tbody>
      </Table>
    </Box>
    <Box cols={3} rows={2}>
      <h2>Items ({supplier.items.count})</h2>
      <Table>
        <thead>
          <tr>
            <th>SCN</th>
            <th>Product</th>
          </tr>
        </thead>
        <tbody>
          {supplier.items.items.map((item) => {
            return <tr key={item.id}>
              <Cell>{item.stockControlNumber}</Cell>
              <Cell>{item.product.name}</Cell>
            </tr>
          })}
        </tbody>
      </Table>
    </Box>
  </Page>
}